import { useEffect, useState } from "react";
import api from "../../api/axios";

import AppLayout from "../../layouts/AppLayout";
import SettingCard from "../../components/SettingCard";

function Stock() {

    const [list, setList] = useState([]);

    useEffect(() => {

        load();

    }, []);

    const load = () => {

        api.get("/auto/search/candidate")

            .then(res => {

                setList(res.data);

            });

    };

    const star = (score) => {

        if (score >= 90) return "★★★★★";

        if (score >= 80) return "★★★★☆";

        if (score >= 70) return "★★★☆☆";

        if (score >= 60) return "★★☆☆☆";

        return "★☆☆☆☆";

    };

    const scoreColor = (score) => {

        if (score >= 90) return "#2ecc71";

        if (score >= 80) return "#3498db";

        if (score >= 70) return "#f39c12";

        return "#888";

    };

    return (

        <AppLayout

            title="추천종목"

            subTitle="자동매매 후보"

        >

            <SettingCard title={`추천 후보 (${list.length})`}>

                <div
                    style={{
                        fontSize: 13,
                        color: "#666"
                    }}
                >

                    SearchEngine 분석 결과

                </div>

            </SettingCard>

            {

                list.map((item, index) => (

                    <SettingCard

                        key={item.stockCode}

                        title={`${index + 1}위  ${item.stockName}`}

                    >

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >

                            <div>

                                <div
                                    style={{
                                        fontSize: 13,
                                        color: "#888"
                                    }}
                                >

                                    {item.stockCode}

                                </div>

                                <div
                                    style={{
                                        marginTop: 6,
                                        color: "#666",
                                        fontSize: 13
                                    }}
                                >

                                    {item.reason}

                                </div>

                            </div>

                            <div
                                style={{
                                    textAlign: "right"
                                }}
                            >

                                <div
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 24,
                                        color: scoreColor(item.score)
                                    }}
                                >

                                    {item.score}

                                </div>

                                <div
                                    style={{
                                        color: "#f1c40f",
                                        fontSize: 14
                                    }}
                                >

                                    {star(item.score)}

                                </div>

                            </div>

                        </div>

                    </SettingCard>

                ))

            }

        </AppLayout>

    );

}

export default Stock;